import { Mail, Phone, Printer, FileText } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function Impressum() {
  useSEO({
    title: "Impressum · Caravan Reisen",
    description: "Impressum und rechtliche Angaben von Caravan Reisen, Inh. Wieland Neumann, Taubenheimer Weg 3, 02742 Neusalza-Spremberg. USt-ID DE 814 952 427.",
    path: "/impressum",
  });

  return (
    <div className="pt-32 pb-16 max-w-3xl mx-auto px-6 lg:px-10" data-testid="impressum-page">
      <span className="chip">Rechtliches</span>
      <h1 className="section-title mt-4 text-5xl md:text-6xl">Impressum</h1>

      <div className="mt-12 bg-white rounded-2xl border border-[#D8D6D0] p-8 md:p-10 space-y-8">
        <section>
          <h2 className="font-display font-semibold text-xl mb-3 flex items-center gap-2">
            <FileText size={18} className="text-[#C05C42]" /> Angaben gemäß § 5 TMG
          </h2>
          <address className="not-italic text-[#1B2A22]/85 leading-relaxed">
            <strong className="text-[#1B2A22]">Caravan Reisen</strong><br/>
            Inh.: Wieland Neumann<br/>
            Taubenheimer Weg 3<br/>
            D-02742 Neusalza-Spremberg<br/>
            Germany
          </address>
        </section>

        <section>
          <h2 className="font-display font-semibold text-xl mb-3 flex items-center gap-2">
            <Phone size={18} className="text-[#C05C42]" /> Kontakt
          </h2>
          <ul className="space-y-2 text-[#1B2A22]/85">
            <li className="flex items-center gap-3">
              <Phone size={14} className="text-[#1B2A22]/50" />
              Telefon: <a href="tel:+4935872699010" className="hover:text-[#C05C42]">+49 (0)35872 / 6990-10</a>
            </li>
            <li className="flex items-center gap-3">
              <Printer size={14} className="text-[#1B2A22]/50" />
              Telefax: +49 (0)35872 / 6990-19
            </li>
            <li className="flex items-center gap-3">
              <Mail size={14} className="text-[#1B2A22]/50" />
              E-Mail: <a href="mailto:info@caravan-reisen.com" className="hover:text-[#C05C42]">info@caravan-reisen.com</a>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-semibold text-xl mb-3">Umsatzsteuer-ID</h2>
          <p className="text-[#1B2A22]/85">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br/>
            <strong>DE 814 952 427</strong>
          </p>
        </section>

        <section>
          <h2 className="font-display font-semibold text-xl mb-3">Verantwortlich für den Inhalt</h2>
          <p className="text-[#1B2A22]/85">
            Wieland Neumann<br/>
            Taubenheimer Weg 3, D-02742 Neusalza-Spremberg
          </p>
        </section>

        <section>
          <h2 className="font-display font-semibold text-xl mb-3">Haftungsausschluss</h2>
          <p className="text-[#1B2A22]/85 leading-relaxed text-sm">
            Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
            Für Inhalte externer Links sind ausschließlich deren Betreiber verantwortlich.
          </p>
        </section>
      </div>
    </div>
  );
}
